import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Form} from 'react-final-form';

import {Link, SaveButton, TextField, Checkbox, Panel} from '../../common';
import {
  MIN_PASSWORD_LEN,
  MAX_NAME_LEN,
  MAX_PASSWORD_LEN,
  MAX_EMAIL_LEN,
  EMAIL_REGEXP,
} from '../../../configs/constants';
import {
  accetPrivacyPolicy,
  noSpacesErrorMessage,
  nolessErrorMessage,
  nolongerErrorMessage,
  passwordDoesNotMatch,
  retypedPasswordDoesNotMatch,
  emailIdInvalid,
} from '../../../configs/messages';

export default class SignUp extends Component {
  static propTypes = {
    signUpRequest: PropTypes.func.isRequired,
  };

  onFormSubmit = (values) => {
    const {signUpRequest} = this.props;

    signUpRequest({
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      password: values.password,
    });
  }

  checkPrivacyPolicy = value => (value ? null : accetPrivacyPolicy);

  validatePassword = (password = '', allValues = {}) => {
    const passwordTrimmed = password.trim();
    const savedPassword = allValues.confirmPassword;

    if (/\s/g.test(password)) {
      return noSpacesErrorMessage('Password');
    }
    if (passwordTrimmed.length < MIN_PASSWORD_LEN) {
      return nolessErrorMessage('Password', MIN_PASSWORD_LEN);
    }
    if (passwordTrimmed.length > MAX_PASSWORD_LEN) {
      return nolongerErrorMessage('Password', MAX_PASSWORD_LEN);
    }
    if (savedPassword && passwordTrimmed !== savedPassword) {
      return passwordDoesNotMatch;
    }

    return null;
  }

  validateConfirmPassword = (password = '', allValues = {}) => {
    const passwordTrimmed = password && password.trim();
    const savedPassword = allValues.password;

    if (/\s/g.test(password)) {
      return noSpacesErrorMessage('Password');
    }
    if (passwordTrimmed.length < MIN_PASSWORD_LEN) {
      return nolessErrorMessage('Password', MIN_PASSWORD_LEN);
    }
    if (passwordTrimmed.length > MAX_PASSWORD_LEN) {
      return nolongerErrorMessage('Password', MAX_PASSWORD_LEN);
    }
    if (savedPassword && passwordTrimmed !== savedPassword) {
      return retypedPasswordDoesNotMatch;
    }

    return null;
  }

  validateName = (name = '', allValues, label) => {
    if (name.length > MAX_NAME_LEN) {
      return nolongerErrorMessage(label, MAX_NAME_LEN);
    }

    return null;
  }

  validateEmail = (email = '') => {
    if (!email.match(EMAIL_REGEXP)) {
      return emailIdInvalid;
    }
    if (email.length > MAX_EMAIL_LEN) {
      return nolongerErrorMessage('Email', MAX_EMAIL_LEN);
    }

    return null;
  }

  renderAcceptLabel = () => (
    <div>
      I agree to the&nbsp;
      <Link to="/terms" text="Terms of Use"/>&nbsp;and&nbsp;
      <Link to="/privacy" text="Privacy Policy"/>
    </div>
  );

  renderLink = () => (
    <Link to="/sign-in" theme="secondary" size="xs" type="button" text="Already registered?" icon="plus" className="button_rounded"/>
  );

  render() {
    return (
      <Panel
        title="Register to get started"
        size="m"
        renderActions={this.renderLink()}
        cls="sign-up"
      >
        <Form
          onSubmit={this.onFormSubmit}
          validateOnBlur={false}
          render={({handleSubmit, submitting}) => (
            <form className="form form_m" onSubmit={handleSubmit}>
              <TextField
                label="First Name"
                name="firstName"
                validatorsArray={[this.validateName]}
                required
              />
              <TextField
                label="Last Name"
                name="lastName"
                validatorsArray={[this.validateName]}
                required
              />
              <TextField
                label="Email"
                name="email"
                type="email"
                maxLength={256}
                validatorsArray={[this.validateEmail]}
                required
              />
              <TextField
                label="Password"
                name="password"
                inputType="password"
                validatorsArray={[this.validatePassword]}
                required
              />
              <TextField
                label="Retype Password"
                name="confirmPassword"
                inputType="password"
                validatorsArray={[this.validateConfirmPassword]}
                required
              />
              <Checkbox
                label={this.renderAcceptLabel()}
                name="accept"
                rowGap="m"
                validatorsArray={[this.checkPrivacyPolicy]}
                cls="terms-condition"
              />
              <div className="row row_center">
                <SaveButton size="xl" type="submit" text="Register" disabled={submitting}/>
              </div>
              <div className="row row_center">
                <Link to="/sign-in" theme="secondary" size="xl" type="button" text="Already registered?" className="sign-up__login-btn"/>
              </div>
            </form>
          )}
        />
      </Panel>
    );
  }
}
